// Amaranto — Bilingual ES/EN content. Intentional gifting copy (timeless, evergreen).
export const translations = {
  es: {
    nav: {
      manifesto: "Manifiesto",
      services: "Servicios",
      kits: "Kits",
      hero: "Bombonera",
      craft: "Artesanía",
      corporate: "Corporativo",
      contact: "Contacto",
      quote: "Apartar",
    },
    hero: {
      eyebrow: "Ciudad de México · Regalos con intención",
      title1: "Un regalo",
      title2: "que se siente.",
      sub: "Hacemos nuestros aromas, velas, jabones, sprays, difusores, galletas y tisanas. Lo demás lo elegimos con artesanos mexicanos. Los vinos, seleccionados para la marca.",
      cta1: "Conversar por WhatsApp",
      cta2: "Ver los kits",
    },
    manifesto: {
      eyebrow: "Quiénes somos",
      title: "No todas las cajas guardan lo mismo.",
      body: "Creamos regalos que se sienten personales desde el primer momento. Combinamos aromas, objetos y detalles cuidadosamente elegidos para que cada kit tenga intención, presencia y sentido. No buscamos llenar una caja: buscamos que quien la reciba realmente la disfrute.",
      pillars: [
        { k: "Hecho por nosotros", v: "Aromas, velas, jabones, sprays, difusores, galletas y tisanas." },
        { k: "Con artesanos mexicanos", v: "Canastas, cerámica, vasos y piezas elegidas." },
        { k: "Vinos seleccionados", v: "No comerciales. Elegidos para la marca." },
      ],
    },
    services: {
      eyebrow: "Cómo regalamos",
      title: "Cuatro formas de componer un detalle.",
      sub: "Cada gesto pide su propio empaque. Diseñamos la experiencia según el momento, no al revés.",
      items: [
        { tag: "01", name: "Regalo personal", body: "Kits listos para el cumpleaños, la disculpa, la bienvenida o el simple hecho de pensar en alguien. Composición íntima, mensaje a mano.", cta: "Conversar por WhatsApp" },
        { tag: "02", name: "Regalo corporativo", body: "Ediciones a medida para equipos, clientes e invitados. Tiempo, atención y empaque firmado. Disponibilidad desde 10 piezas.", cta: "Solicitar cotización" },
        { tag: "03", name: "Experiencias curadas", body: "Proyectos para pedidas, bautizos, comuniones, aniversarios o agradecimientos. Cada uno se diseña con planeación previa y disponibilidad.", cta: "Conversar el proyecto" },
        { tag: "04", name: "Custom gifting", body: "De cero a la medida: empaque propio, materiales elegidos contigo, tarjetón impreso, edición numerada. Para gestos que no caben en una caja estándar.", cta: "Crear mi edición" },
      ],
    },
    kits: {
      eyebrow: "Colección Esencial",
      title: "Kits curados, en edición limitada.",
      sub: "Composiciones pensadas con calma. Cuando un kit se agota, dejamos espacio para una nueva edición.",
      items: [
        {
          code: "Kit · 01",
          name: "Serena",
          tagline: "Aromas suaves y pequeños rituales para disfrutar el hogar todos los días.",
          price: "$1,150 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img3.jpg",
          contents: [
            "Spray RESPIRA · bruma de baño · eucalipto & bergamota",
            "Spray LINO · para almohadas y textiles · lavanda & neroli",
            "Jabón artesanal Amaranto",
            "Base de canasta artesanal (Panera) · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 02",
          name: "Ritual",
          tagline: "Un ritual completo de aromas que invita a pausar, respirar y reconectar.",
          price: "$1,350 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img4.jpg",
          contents: [
            "Detalle de flores conservadas",
            "Spray RESPIRA · bruma de baño · eucalipto & bergamota",
            "Vela BLANC · lavanda & neroli",
            "Spray LINO · para almohadas y textiles · lavanda & neroli",
            "Canasto tejido (Panera) + empaque Amaranto",
          ],
        },
        {
          code: "Kit · 03",
          name: "Esencia",
          tagline: "Lo esencial para llenar de fragancia y calidez cualquier rincón del hogar.",
          price: "$1,400 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img5.jpg",
          contents: [
            "Spray RESPIRA · bruma de baño · eucalipto & bergamota",
            "Spray LINO · para almohadas y textiles · lavanda & neroli",
            "Jabón artesanal Amaranto",
            "Vela BLANC · lavanda & neroli",
            "Base de canasta artesanal (Panera) · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 04",
          name: "Refugio",
          tagline: "Una pausa pensada para regalar calma, aroma y un momento de tranquilidad.",
          price: "$1,500 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img6.jpg",
          contents: [
            "Ramo de flores conservadas",
            "Spray RESPIRA · bruma de baño · eucalipto & bergamota",
            "Vela BLANC · lavanda & neroli",
            "Jabón artesanal de uso corporal",
            "Almendras cubiertas de chocolate",
            "Canasta tejida + empaque Amaranto",
          ],
        },
        {
          code: "Kit · 05",
          name: "Bienestar",
          tagline: "Una experiencia completa para desconectarse, descansar y disfrutar cada sentido.",
          price: "$1,700 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img7.jpg",
          contents: [
            "Spray RESPIRA · bruma de baño · eucalipto & bergamota",
            "Vela BLANC · lavanda & neroli",
            "Spray LINO · para almohadas y textiles · lavanda & neroli",
            "Jabón artesanal Amaranto",
            "Esponja vegetal + cepillo de madera",
            "Caja de madera · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 06",
          name: "Tinto",
          tagline: "Una combinación cálida para acompañar conversaciones, cenas y momentos especiales.",
          price: "$1,850 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img8.jpg",
          contents: [
            "Vino tinto Alebrino",
            "Vela BLANC · lavanda & neroli",
            "Almendras con chocolate",
            "Detalle de flores conservadas de temporada",
            "Jabón artesanal Amaranto",
            "Caja con tapa · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 07",
          name: "Raíz",
          tagline: "Una combinación pensada para compartir, desconectarse y convertir cualquier momento en algo especial.",
          price: "$1,900 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img10.jpg",
          contents: [
            "Mezcal Campante 375 ml",
            "Vela BLANC · lavanda & neroli",
            "Almendras con chocolate",
            "Flores conservadas de temporada",
            "Par de vasos tequileros",
            "Caja de madera · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 08",
          name: "Brindis",
          tagline: "Vino, aroma y flores: todo lo que necesitas para hacer de un momento algo memorable.",
          price: "$1,950 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img11.jpg",
          contents: [
            "Vino Da Luca",
            "Vela BLANC · lavanda & neroli",
            "Almendras con chocolate",
            "Flores conservadas de temporada",
            "Jabón artesanal Amaranto",
            "Caja con tapa · empaque Amaranto",
          ],
        },
        {
          code: "Kit · 09",
          name: "Equilibrio",
          tagline: "Naturaleza, sabor y calma reunidos en una sola canasta.",
          price: "$1,800 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img9.jpg",
          contents: [
            "Canasta mediana · moños y tarjetón",
            "Almendras con chocolate",
            "Galletas artesanales · avena y arándanos",
            "Tizana artesanal Amaranto",
            "Flores naturales de temporada",
            "Termo mate · hidratación diaria",
          ],
        },
        {
          code: "Kit · 10",
          name: "Rosé",
          tagline: "Un detalle pensado para celebrar, compartir y brindar bonito.",
          price: "$2,200 MXN",
          shipping: "Envío incluido",
          img: "/catalog/img12.jpg",
          contents: [
            "Vino Rosé Da Luca",
            "Vela BLANC · lavanda & neroli",
            "Arreglo de flores naturales",
            "Galletas Noche · almendras, chocolate y naranja",
            "Almendras con chocolate",
            "Canasta mediana · empaque Amaranto",
          ],
        },
      ],
      cta: "Apartar por WhatsApp",
    },
    heroProduct: {
      eyebrow: "Producto héroe",
      title1: "Bombonera",
      title2: "de Peonía",
      sub: "La pieza que se regala sola. Y lo dice todo.",
      bullets: [
        "Vela aromática en bombonera de cristal con tapa · 500 ml",
        "Aroma limpio, suave y elegante",
        "Caja de presentación Amaranto",
        "Listón + detalle floral",
        "Tarjetón con mensaje personalizado",
      ],
      price: "$1,100 MXN",
      shipping: "Envío incluido",
      cta: "Apartar la bombonera",
    },
    craft: {
      eyebrow: "El detalle Amaranto",
      title: "Lo que hace que se sienta diferente.",
      sub: "Cada categoría tiene su origen. Nosotros lo elegimos. Esto es lo que verás dentro.",
      items: [
        { n: "01", k: "Aromas propios", v: "Diseñamos los aromas en casa. Velas, sprays y difusores hechos por nosotros en pequeñas tandas." },
        { n: "02", k: "Jabones del taller", v: "Recetas propias, formuladas y elaboradas en casa con tiempo y atención." },
        { n: "03", k: "Galletas y tisanas", v: "Horneamos las galletas y componemos las tisanas. Cualquier receta que la caja necesite, la hacemos nosotros." },
        { n: "04", k: "Con artesanos mexicanos", v: "Canastas, cerámica, vasos y piezas elegidas pieza por pieza con cada taller." },
        { n: "05", k: "Vinos seleccionados", v: "Etiquetas elegidas para la marca. No comerciales. Acompañan, no llenan." },
        { n: "06", k: "Empaque firmado", v: "Canasta tejida o caja con tapa, papel de seda, listón en dusty rose o champagne, sellado a mano." },
      ],
    },
    order: {
      eyebrow: "Cómo apartar tu kit",
      title: "Cinco pasos, sin prisa.",
      steps: [
        { n: "01", t: "Escríbenos por WhatsApp", d: "Cuéntanos para quién y la fecha en la que la quieres entregar." },
        { n: "02", t: "Elige tu kit y personaliza el mensaje", d: "Sumamos el tarjetón impreso y un detalle del empaque." },
        { n: "03", t: "Confirmamos disponibilidad", d: "Solo armamos kits limitados. Cuando se van, se van." },
        { n: "04", t: "Pago por transferencia", d: "Te enviamos los datos y confirmamos por WhatsApp." },
        { n: "05", t: "Recibe tu pedido", d: "Empaque premium, listón y tarjetón, listo para regalar." },
      ],
      note: "Kits personales y proyectos corporativos · CDMX y área metropolitana",
    },
    corporate: {
      eyebrow: "Regalo corporativo",
      title: "Detalles que hablan por tu marca.",
      sub: "Diseñamos el detalle contigo. Materiales elegidos, mensaje único y entrega coordinada en CDMX y área metropolitana.",
      form: {
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        company: "Empresa",
        occasion: "Ocasión",
        quantity: "Cantidad estimada",
        message: "Cuéntanos sobre el detalle que imaginas",
        submit: "Solicitar cotización",
        sending: "Enviando…",
        success: "Gracias. Te responderemos a la brevedad.",
        error: "Algo salió mal. Intenta de nuevo o escríbenos por WhatsApp.",
      },
    },
    instagram: {
      eyebrow: "Instagram",
      title: "@soyamaranto.mx",
      sub: "Detrás del taller, las piezas que viajan hoy y los aromas que se enfrían en cera.",
      follow: "Seguir en Instagram",
    },
    closing: {
      eyebrow: "Amaranto · Regalos hechos con intención",
      title1: "Hay regalos que se abren…",
      title2: "y otros que se sienten.",
      cta: "Conversar por WhatsApp",
    },
    footer: {
      tagline: "Curaduría de regalos hechos con intención.",
      city: "Ciudad de México · área metropolitana",
      rights: "Todos los derechos reservados.",
      links: { kits: "Kits", corporate: "Corporativo", contact: "Contacto", instagram: "Instagram" },
    },
  },
  en: {
    nav: {
      manifesto: "Manifesto",
      services: "Services",
      kits: "Kits",
      hero: "Bombonera",
      craft: "Craft",
      corporate: "Corporate",
      contact: "Contact",
      quote: "Reserve",
    },
    hero: {
      eyebrow: "Mexico City · Intentional gifting",
      title1: "A gift",
      title2: "you can feel.",
      sub: "We make our scents, candles, soaps, mists, diffusers, cookies and herbal teas. The rest we choose with Mexican artisans. The wines, selected for the brand.",
      cta1: "Chat on WhatsApp",
      cta2: "View the kits",
    },
    manifesto: {
      eyebrow: "Who we are",
      title: "Not every box holds the same thing.",
      body: "We craft gifts that feel personal from the very first moment. We combine scents, objects and details, carefully chosen, so that every kit holds intention, presence and meaning. We don't aim to fill a box: we aim for the one who receives it to truly enjoy it.",
      pillars: [
        { k: "Made by us", v: "Scents, candles, soaps, mists, diffusers, cookies and herbal teas." },
        { k: "With Mexican artisans", v: "Baskets, ceramics, glasses and selected pieces." },
        { k: "Selected wines", v: "Non-commercial. Chosen for the brand." },
      ],
    },
    services: {
      eyebrow: "How we gift",
      title: "Four ways to compose a gesture.",
      sub: "Each gesture asks for its own packaging. We design the experience around the moment, not the other way round.",
      items: [
        { tag: "01", name: "Personal gifting", body: "Kits ready for a birthday, an apology, a welcome, or the simple act of thinking of someone. Intimate composition, handwritten card.", cta: "Chat on WhatsApp" },
        { tag: "02", name: "Corporate gifting", body: "Bespoke editions for teams, clients and guests. Time, care and signed packaging. Available from 10 pieces.", cta: "Request a quote" },
        { tag: "03", name: "Curated experiences", body: "Projects for engagements, christenings, communions, anniversaries or thank-yous. Each is designed with prior planning and availability.", cta: "Talk through the project" },
        { tag: "04", name: "Custom gifting", body: "From scratch: your own packaging, materials chosen with you, printed card, numbered edition. For gestures that don't fit a standard box.", cta: "Create my edition" },
      ],
    },
    kits: {
      eyebrow: "Essential Collection",
      title: "Curated kits in limited edition.",
      sub: "Compositions made with patience. When a kit sells out, we leave room for a new edition.",
      items: [
        { code: "Kit · 01", name: "Serena", tagline: "Soft scents and small rituals to enjoy your home every day.", price: "$1,150 MXN", shipping: "Shipping included", img: "/catalog/img3.jpg",
          contents: ["Spray RESPIRA · bath mist · eucalyptus & bergamot", "Spray LINO · for pillows and textiles · lavender & neroli", "Amaranto artisanal soap", "Artisanal basket base (Panera) · Amaranto packaging"] },
        { code: "Kit · 02", name: "Ritual", tagline: "A complete ritual of scents that invites you to pause, breathe and reconnect.", price: "$1,350 MXN", shipping: "Shipping included", img: "/catalog/img4.jpg",
          contents: ["Preserved flower detail", "Spray RESPIRA · bath mist · eucalyptus & bergamot", "BLANC candle · lavender & neroli", "Spray LINO · for pillows and textiles · lavender & neroli", "Woven basket (Panera) + Amaranto packaging"] },
        { code: "Kit · 03", name: "Esencia", tagline: "The essentials to fill any corner of the home with fragrance and warmth.", price: "$1,400 MXN", shipping: "Shipping included", img: "/catalog/img5.jpg",
          contents: ["Spray RESPIRA · bath mist · eucalyptus & bergamot", "Spray LINO · for pillows and textiles · lavender & neroli", "Amaranto artisanal soap", "BLANC candle · lavender & neroli", "Artisanal basket base (Panera) · Amaranto packaging"] },
        { code: "Kit · 04", name: "Refugio", tagline: "A pause designed to gift calm, scent and a moment of stillness.", price: "$1,500 MXN", shipping: "Shipping included", img: "/catalog/img6.jpg",
          contents: ["Preserved flower bouquet", "Spray RESPIRA · bath mist · eucalyptus & bergamot", "BLANC candle · lavender & neroli", "Artisanal body soap", "Chocolate-covered almonds", "Woven basket + Amaranto packaging"] },
        { code: "Kit · 05", name: "Bienestar", tagline: "A complete experience to disconnect, rest and enjoy every sense.", price: "$1,700 MXN", shipping: "Shipping included", img: "/catalog/img7.jpg",
          contents: ["Spray RESPIRA · bath mist · eucalyptus & bergamot", "BLANC candle · lavender & neroli", "Spray LINO · for pillows and textiles · lavender & neroli", "Amaranto artisanal soap", "Vegetal sponge + wooden brush", "Wooden box · Amaranto packaging"] },
        { code: "Kit · 06", name: "Tinto", tagline: "A warm composition to accompany conversations, dinners and special moments.", price: "$1,850 MXN", shipping: "Shipping included", img: "/catalog/img8.jpg",
          contents: ["Alebrino red wine", "BLANC candle · lavender & neroli", "Chocolate-covered almonds", "Seasonal preserved flowers", "Amaranto artisanal soap", "Lidded box · Amaranto packaging"] },
        { code: "Kit · 07", name: "Raíz", tagline: "A composition meant to share, unwind and turn any moment into something special.", price: "$1,900 MXN", shipping: "Shipping included", img: "/catalog/img10.jpg",
          contents: ["Campante mezcal 375 ml", "BLANC candle · lavender & neroli", "Chocolate-covered almonds", "Seasonal preserved flowers", "Pair of tequila glasses", "Wooden box · Amaranto packaging"] },
        { code: "Kit · 08", name: "Brindis", tagline: "Wine, scent and flowers — everything you need to make a moment memorable.", price: "$1,950 MXN", shipping: "Shipping included", img: "/catalog/img11.jpg",
          contents: ["Da Luca wine", "BLANC candle · lavender & neroli", "Chocolate-covered almonds", "Seasonal preserved flowers", "Amaranto artisanal soap", "Lidded box · Amaranto packaging"] },
        { code: "Kit · 09", name: "Equilibrio", tagline: "Nature, flavor and calm gathered into a single basket.", price: "$1,800 MXN", shipping: "Shipping included", img: "/catalog/img9.jpg",
          contents: ["Medium basket · ribbons and card", "Chocolate-covered almonds", "Artisanal cookies · oat and cranberry", "Amaranto herbal tea", "Seasonal fresh flowers", "Mate thermos · daily hydration"] },
        { code: "Kit · 10", name: "Rosé", tagline: "A detail designed to celebrate, share and toast beautifully.", price: "$2,200 MXN", shipping: "Shipping included", img: "/catalog/img12.jpg",
          contents: ["Da Luca Rosé wine", "BLANC candle · lavender & neroli", "Fresh flower arrangement", "Noche cookies · almonds, chocolate and orange", "Chocolate-covered almonds", "Medium basket · Amaranto packaging"] },
      ],
      cta: "Reserve via WhatsApp",
    },
    heroProduct: {
      eyebrow: "Hero product",
      title1: "Peony",
      title2: "Bombonera",
      sub: "The piece that gifts itself. And says everything.",
      bullets: [
        "Aromatic candle in lidded glass bombonera · 500 ml",
        "Clean, soft and elegant scent",
        "Amaranto presentation box",
        "Ribbon + floral detail",
        "Card with a personal message",
      ],
      price: "$1,100 MXN",
      shipping: "Shipping included",
      cta: "Reserve the bombonera",
    },
    craft: {
      eyebrow: "The Amaranto detail",
      title: "What makes it feel different.",
      sub: "Each category has its own origin. We choose it. This is what you'll find inside.",
      items: [
        { n: "01", k: "Our own scents", v: "We design the scents in-house. Candles, mists and diffusers made by us in small batches." },
        { n: "02", k: "Atelier soaps", v: "Our own formulas, prepared in-house with time and care." },
        { n: "03", k: "Cookies and herbal teas", v: "We bake the cookies and compose the herbal teas. Any recipe the box needs, we make it ourselves." },
        { n: "04", k: "With Mexican artisans", v: "Baskets, ceramics, glasses and pieces chosen one by one with each workshop." },
        { n: "05", k: "Selected wines", v: "Labels chosen for the brand. Non-commercial. They accompany, they don't fill." },
        { n: "06", k: "Signed packaging", v: "Woven basket or lidded box, tissue paper, dusty rose or champagne ribbon, hand-sealed." },
      ],
    },
    order: {
      eyebrow: "How to reserve your kit",
      title: "Five steps, unhurried.",
      steps: [
        { n: "01", t: "Write to us on WhatsApp", d: "Tell us who it's for and the delivery date." },
        { n: "02", t: "Choose your kit and personalize the message", d: "Personalize the card and the packaging detail." },
        { n: "03", t: "We confirm availability", d: "We only compose limited kits. Once gone, gone." },
        { n: "04", t: "Bank transfer", d: "We share the details and confirm on WhatsApp." },
        { n: "05", t: "Receive your order", d: "Premium packaging, ribbon and card, ready to gift." },
      ],
      note: "Personal kits and corporate projects · Mexico City and metro area",
    },
    corporate: {
      eyebrow: "Corporate Gifting",
      title: "Details that speak for your brand.",
      sub: "We design the detail with you. Materials chosen together, a unique message and coordinated delivery across Mexico City and metro area.",
      form: {
        name: "Name", email: "Email", phone: "Phone (optional)", company: "Company", occasion: "Occasion",
        quantity: "Estimated quantity", message: "Tell us about the detail you have in mind",
        submit: "Request a quote", sending: "Sending…",
        success: "Thank you. We will be in touch shortly.",
        error: "Something went wrong. Please try again or write us on WhatsApp.",
      },
    },
    instagram: {
      eyebrow: "Instagram", title: "@soyamaranto.mx",
      sub: "Behind the atelier, the pieces traveling today and the scents cooling in wax.",
      follow: "Follow on Instagram",
    },
    closing: {
      eyebrow: "Amaranto · Gifts made with intention",
      title1: "Some gifts are opened…",
      title2: "others are felt.",
      cta: "Chat on WhatsApp",
    },
    footer: {
      tagline: "A curation of gifts made with intention.",
      city: "Mexico City · metro area",
      rights: "All rights reserved.",
      links: { kits: "Kits", corporate: "Corporate", contact: "Contact", instagram: "Instagram" },
    },
  },
};

export const CONTACT = {
  whatsappNumber: "5215541321692",
  whatsappDisplay: "+52 55 4132 1692",
  instagramHandle: "soyamaranto.mx",
  schedule: {
    es: {
      title: "Horario de atención",
      lines: ["Lunes a Viernes · 9 AM — 6 PM", "Sábado · 9 AM — 3 PM"],
    },
    en: {
      title: "Business hours",
      lines: ["Monday to Friday · 9 AM — 6 PM", "Saturday · 9 AM — 3 PM"],
    },
  },
};
